import startCase from "lodash/startCase";
import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";

import Pill from "@stadium/ui/src/components/pill";
import { getCcTypeImage } from "@stadium/checkout/src/components/payment-options/cards/utils";

import styles from "./main.module.scss";

const Card = ({ card, onClick }) => {
  const { id, name, lastDigits, ccType } = card;
  const cardImage = getCcTypeImage({ ccType });

  return (
    <div
      className={styles.addedCard}
      data-dd-privacy="mask"
      data-dd-action-name="Payment Section Credit card"
      key={`card-${id}`}
      onClick={onClick}
    >
      <div className={styles.cardBox}>
        <div className={styles.cardImageContainer}>
          {cardImage && (
            <Multimedia
              alt={`${ccType}-image`}
              type="image"
              src={cardImage}
              className={styles.cardImage}
            />
          )}
        </div>

        <div className={styles.detailContainer}>
          <div className={styles.cardNameContainer}>
            <div className={styles.cardName}>{startCase(name) || "Credit Card"}</div>
            {card.default && (
              <Pill color="light" className={styles.pillBtn}>
                Preferred
              </Pill>
            )}
            {card.isExpired && (
              <Pill color="pink" className={`${styles.pillBtn} ${styles.expiredPill}`}>
                Expired
              </Pill>
            )}
          </div>
          <div className={styles.cardDetail}>**** {lastDigits}</div>
        </div>
      </div>
    </div>
  );
};

export default Card;
